import React, { useContext } from "react";
import { Spin } from "antd";
import ProjectionModal from "../../../ProjectionModal";
import style from "./index.module.scss";
import useRequest from "utils/useRequest";
import { CourseContext, resourceModalAtom } from "../../../../Store";
import CustomEmpty from "components/CourseComponents/CustomEmpty";
import { useAtom } from "jotai";
import ListItemV2 from "../../../../../../components/CourseComponents/Resource/ListItem";
import useCurrentDate from "../../../../../../utils/useCurrentDate";
import { getSourceList } from "../../../../../ResourcePool/service";
import { useHistory } from "react-router-dom";

export default function ResourceModal() {
    const { course, basename } = useContext(CourseContext);
    const { batchNo } = useCurrentDate();
    const [data, { loading }] = useRequest(() =>
        getSourceList({
            batchNo,
            delStatus: "",
            courseNo: course.courseNo,
            courseSeq: course.courseSeq,
            keyword: "",
            pageNo: 1,
            pageSize: 9999,
            weektimeId: course.weekTimeId
        })
    );

    const [resourceModalState, setResourceModalState] =
        useAtom(resourceModalAtom);

    //投屏
    const history = useHistory();
    function gotoDetail(id: number) {
        history.replace(`${basename}/resource?id=${id}`);
        setResourceModalState(null);
    }

    return (
        <ProjectionModal
            title="课件列表"
            visible={resourceModalState === "resource"}
            onCancel={() => setResourceModalState(null)}>
            <div className={style.root}>
                <div className={style.header}>
                    <div className={style.count}>
                        课件（{data?.data?.length || 0}）
                    </div>
                </div>

                <div className={style.main}>
                    <Spin spinning={loading}>
                        {data?.data?.map(item => (
                            <div key={item.id} style={{ marginBottom: 15 }}>
                                <ListItemV2
                                    onProjection={gotoDetail}
                                    source={item}
                                    model="screencast"
                                />
                            </div>
                        ))}
                        {data?.data?.length === 0 && (
                            <CustomEmpty style={{ padding: "100px 0" }} />
                        )}
                    </Spin>
                </div>
            </div>
        </ProjectionModal>
    );
}
